<template>
  <div class="system-mian">
    <el-scrollbar>
      <div style="margin: 20px 200px">
        <el-button
          v-if="readonlys"
          v-show="saveState"
          type="primary"
          size=""
          @click="clickTip"
        >修改</el-button>
        <el-button
          v-else
          type="primary"
          size=""
          @click="_modify"
        >保存</el-button>
      </div>

      <el-form ref="form" :model="form" :rules="rules" label-width="200px">
        <el-form-item
          label="是否启用用户操作日志"
          prop="fIsEnableLogForOperation"
        >
          <el-radio-group
            v-model="form.fIsEnableLogForOperation"
            :disabled="readonlys"
          >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="销售记录允许负库存"
          prop="fIsDistributorStock"
        >
          <el-radio-group
            v-model="form.fIsDistributorStock"
            :disabled="readonlys"
          >
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="IP查询链接地址" prop="fIpInquiryAddress">
          <el-input v-model="form.fIpInquiryAddress" :disabled="readonlys" />
        </el-form-item>
        <el-form-item label="上传文件大小(Kb为单位)" prop="fUploadFileSize">

          <el-input-currency v-model="form.fUploadFileSize" :scale="0" size="" :disabled="readonlys" />

        </el-form-item>
        <el-form-item label="允许登入时密码出错次数" prop="fPassWordErrors">

          <el-input-currency v-model="form.fPassWordErrors" :scale="0" size="" :disabled="readonlys" />

        </el-form-item>
        <el-form-item label="禁止登入时间(分钟)" prop="fProhibitTimes">

          <el-input-currency v-model="form.fProhibitTimes" :scale="0" size="" :disabled="readonlys" />

        </el-form-item>
        <el-form-item label="无操作踢出时间(小时)" prop="fNoOperationTimes">

          <el-input-currency v-model="form.fNoOperationTimes" :scale="0" size="" :disabled="readonlys" />

        </el-form-item>
        <el-form-item label="禁止登录IP列表" prop="fProhibitIp">
          <el-input v-model="form.fProhibitIp" :disabled="readonlys" />
        </el-form-item>
        <el-form-item label="递单号查询默认网址" prop="fExpressInquiry">
          <el-input v-model="form.fExpressInquiry" :disabled="readonlys" />
        </el-form-item>
        <div style="text-indent: 200px; color: red; margin-bottom: 10px">
          <p style="margin: 0px">
            https://www.kuaidi100.com/chaxun?com=@dm&nu=@nu
          </p>
          <p style="margin: 0px">格式:[@dm:快递公司编号;@nu:物流单号]</p>
        </div>
        <el-form-item label="送货单打印行数" prop="fDeliveryPrintRows">

          <el-input-currency v-model="form.fDeliveryPrintRows" :scale="0" size="" :disabled="readonlys" />

        </el-form-item>
      </el-form>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        fIsEnableLogForOperation: '',
        fIsDistributorStock: '',
        fIpInquiryAddress: '',
        fUploadFileSize: '',
        fPassWordErrors: '',
        fProhibitTimes: '',
        fNoOperationTimes: '',
        fProhibitIp: '',
        fExpressInquiry: ''
      },
      readonlys: true,
      saveState: true,
      rules: {
        fUploadFileSize: [
          { required: true, message: '必填项', trigger: 'change' }
        ],
        fPassWordErrors: [
          { required: true, message: '必填项', trigger: 'change' }
        ],
        fProhibitTimes: [
          { required: true, message: '必填项', trigger: 'change' }
        ],
        fNoOperationTimes: [
          { required: true, message: '必填项', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.refresh()
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '001007002') {
        this.saveState = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.$httpPost('SystemApplication/SystemConfig/GetSystemConfig', {}).then(
        (res) => {
          this.form = res.datalist
        }
      )
    },
    _modify() {
      this.$confirm('是否保存修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const form = this.form
          this.$httpPost('SystemApplication/SystemConfig/SystemConfigSave', {
            datalist: JSON.stringify({ ...form })
          }).then((res) => {
            // console.log(res, 'res')
            if (res.isSuccess) {
              this.$message.success(res.message)
              this.refresh()
              this.readonlys = true
            } else {
              this.$message.error(res.message)
              throw res.message
            }
          })
        })
        .catch(() => {
          this.refresh()
          this.readonlys = true
          this.$message({
            type: 'info',
            message: '已取消修改'
          })
        })
    },
    clickTip() {
      this.readonlys = false
      this.$message.success('请编辑!')
    }
  }
}
</script>
<style lang='less'>
.system-mian {
  height: calc(100vh - 150px);
  .el-scrollbar {
    height: 100%;
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .el-input.is-disabled .el-input__inner {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #000;
    cursor: not-allowed;
  }
}
</style>
